var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { language } from '../../services/LanguageService';
import { SelectItem, Select, Button, TextInput, getIconComponent } from '../Carbon';
import { Subject, debounceTime } from 'rxjs';
import { AsperaError } from '../../classes/AsperaError';
import { SubManager } from '../../classes/SubManager';
/**
 * This renders the Carbon Data Table pagination bar. This is a direct copy of Carbon's Pagination bar with just a few tweaks for Aspera usage.
 * Some Aspera coding practices/styles are not used on this page to handle the porting of Carbon code over to Aspera Starter.
 */
class AsperaTablePagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            pageSize: 10,
            prevPageSizes: [],
            prevPage: 1,
            prevPageSize: 10,
        };
        this.subManager = new SubManager();
        this.textPagingSubject = new Subject();
        this.handleSizeChange = (event) => {
            const pageSize = Number(event.target.value);
            this.setState({ pageSize, page: 1 });
            this.props.onChange({ page: 1, pageSize });
        };
        this.handlePageChange = (page) => {
            if (page > 0 && page <= Math.max(Math.ceil((this.props.totalItems || 1) / this.state.pageSize), 1)) {
                this.setState({ page });
                this.textPagingSubject.next(page);
            }
        };
        this.handlePageInputChange = (event) => {
            const page = Number(event.target.value);
            this.handlePageChange(page);
        };
        this.handleTextPageInputChange = (event) => {
            const page = Number(event.target.value);
            this.handlePageChange(page);
        };
        this.incrementPage = () => {
            const page = this.state.page + 1;
            this.setState({ page });
            this.props.onChange({ page, pageSize: this.state.pageSize });
        };
        this.decrementPage = () => {
            const page = this.state.page - 1;
            this.setState({ page });
            this.props.onChange({ page, pageSize: this.state.pageSize });
        };
        this.renderSelectItems = (total) => {
            let counter = 1;
            const itemArr = [];
            while (counter <= total) {
                itemArr.push(React.createElement(SelectItem, { key: counter, value: counter, text: String(counter) }));
                counter++;
            }
            return itemArr;
        };
        const { pageSizes, page, pageSize } = this.props;
        this.state = {
            page: page,
            pageSize: pageSize && pageSizes.some((sizeObj) => pageSize === sizeObj.value) ? pageSize : pageSizes[1].value,
            prevPageSizes: pageSizes,
            prevPage: page,
            prevPageSize: pageSize,
        };
    }
    componentDidMount() {
        this.subManager.setSubscription(this.textPagingSubject.pipe(debounceTime(500)).subscribe({
            next: page => {
                this.props.onChange({
                    page,
                    pageSize: this.state.pageSize,
                });
            },
            error: error => {
                new AsperaError('AsperaTablePagination: Unable to subscribe to paging text subscription', error);
            },
        }));
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        const _a = this.props, { backwardText, className, forwardText, id, itemsPerPageText, itemRangeText, pageRangeText, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        pageSize, pageSizes, itemText, pageText, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        pageNumberText, pagesUnknown, isLastPage, disabled, pageInputDisabled, pageSizeInputDisabled, totalItems, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onChange, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        page: pageNumber, size, forwardedRef } = _a, other = __rest(_a, ["backwardText", "className", "forwardText", "id", "itemsPerPageText", "itemRangeText", "pageRangeText", "pageSize", "pageSizes", "itemText", "pageText", "pageNumberText", "pagesUnknown", "isLastPage", "disabled", "pageInputDisabled", "pageSizeInputDisabled", "totalItems", "onChange", "page", "size", "forwardedRef"]);
        const classNames = `cds--pagination ${size ? `cds--pagination--${size}` : ''} ${className}`;
        const inputId = id;
        const { page: statePage, pageSize: statePageSize } = this.state;
        const hasPages = !!totalItems;
        const localPagesUnknown = pagesUnknown || !hasPages;
        const totalPages = hasPages ? Math.max(Math.ceil((totalItems || 1) / statePageSize), 1) : 0;
        const backButtonDisabled = disabled || statePage === 1;
        const backButtonClasses = `cds--pagination__button cds--pagination__button--backward ${backButtonDisabled ? 'cds--pagination__button--no-index' : ''}`;
        const forwardButtonDisabled = disabled || statePage === totalPages;
        const forwardButtonClasses = `cds--pagination__button cds--pagination__button--forward ${forwardButtonDisabled ? 'cds--pagination__button--no-index' : ''}`;
        const renderSelectPageChange = totalPages < 20;
        const selectItems = renderSelectPageChange ? this.renderSelectItems(totalPages) : null;
        return (React.createElement("div", Object.assign({ className: classNames, ref: forwardedRef }, other),
            React.createElement("div", { className: "cds--pagination__left" },
                React.createElement("label", { id: `cds-pagination-select-${inputId}-count-label`, className: "cds--pagination__text", htmlFor: `cds-pagination-select-${inputId}` }, itemsPerPageText),
                React.createElement(Select, { id: `cds-pagination-select-${inputId}`, className: "cds--select__item-count", labelText: "", hideLabel: true, noLabel: true, inline: true, onChange: this.handleSizeChange, disabled: pageSizeInputDisabled || disabled, value: statePageSize }, pageSizes.map((sizeObj) => (React.createElement(SelectItem, { key: sizeObj.value, value: sizeObj.value, text: String(sizeObj.text) })))),
                !localPagesUnknown && React.createElement("span", { className: "cds--pagination__text cds--pagination__items-count" }, pagesUnknown ? itemText(statePageSize * (statePage - 1) + 1, statePage * statePageSize) : itemRangeText(Math.min(statePageSize * (statePage - 1) + 1, (totalItems || 1)), Math.min(statePage * statePageSize, (totalItems || 1)), (totalItems || 1)))),
            React.createElement("div", { className: "cds--pagination__right" },
                !localPagesUnknown && (renderSelectPageChange ? (React.createElement(Select, { id: `cds-pagination-select-${inputId}-right`, className: "cds--select__page-number", labelText: language.get('table.pageLabel', [totalPages]), inline: true, hideLabel: true, onChange: this.handlePageInputChange, value: statePage, disabled: pageInputDisabled || disabled }, selectItems)) : (React.createElement(TextInput, { id: `cds-pagination-text-input-${inputId}-right`, autoComplete: 'off', className: "aspera-text-page-input", labelText: language.get('table.pageLabel', [totalPages]), onChange: this.handleTextPageInputChange, value: statePage, hideLabel: true, inline: true, disabled: pageInputDisabled || disabled }))),
                !localPagesUnknown && React.createElement("span", { className: "cds--pagination__text" }, pagesUnknown ? pageText(statePage) : pageRangeText(statePage, totalPages)),
                React.createElement("div", { className: "cds--pagination__control-buttons" },
                    React.createElement(Button, { kind: "ghost", className: backButtonClasses, hasIconOnly: true, renderIcon: getIconComponent('CaretLeft'), iconDescription: backwardText, tooltipAlignment: "center", tooltipPosition: "top", onClick: this.decrementPage, disabled: backButtonDisabled }),
                    React.createElement(Button, { kind: "ghost", className: forwardButtonClasses, hasIconOnly: true, renderIcon: getIconComponent('CaretRight'), iconDescription: forwardText, tooltipAlignment: "end", tooltipPosition: "top", onClick: this.incrementPage, disabled: (forwardButtonDisabled || isLastPage) && !localPagesUnknown })))));
    }
}
export default AsperaTablePagination;
